// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"2405": "5df1491c","4777": "c617ca52","6983": "22cd1c44","7709": "8d5da1e0","9487": "f3e3de7a","9990": "7f7cd9a7",}[chunkId] + ".css"
}